'use client';

import { useMemo, useState, useCallback } from 'react';
import dynamic from 'next/dynamic';

//* Components
import Page from '@components/global/Page';
import Faq from '@components/pages/Services/Faq';
import TableItem from '@components/global/TableItem';
import Testimonials from '@components/global/Testimonials';
import WhyChoose from '@components/pages/Services/WhyChoose';
import AnimationWrap from '@components/global/AnimationWrap';
import HTMLContainer from '@components/global/HTMLContainer';
import PageTopSection from '@components/global/PageTopSection';
import WorkProcess from '@components/pages/Services/WorkProcess';
const PortfolioShortList = dynamic(() => import('@/components/global/PortfolioShortList'));

//* Styles
import SubServiceStyle from '@/styles/pages/SubServiceStyle';
import withLanguageContext from '@/context/consumerHOC/LanguageConsumer';

const SingleSubService = ({ pageData, translate }) => {
	//! States
	const [secObj, setSecObj] = useState();

	//! Handle Active Section Animation
	const Anim = useCallback(
		(x) => {
			if (JSON.stringify(x) !== JSON.stringify(secObj)) {
				setSecObj(x);
			}
		},
		[secObj]
	);

	const sectionBuilder = useMemo(() => {
		return (
			pageData?.templates?.length > 0 &&
			pageData.templates.map((template, key) => {
				const type = template.type;

				return (
					<div
						key={key}
						className='section-item'>
						{type == 'offer' && template?.children?.length ? (
							<TableItem
								underline
								animationDelay={0.1}
								title={template.title}
								list={template.children}
								active={secObj?.[`sec${key + 1}`]}
							/>
						) : null}

						{type == 'faq' ? pageData.faqs?.length > 0 ? <Faq faqs={pageData.faqs} /> : null : null}

						{type == 'work_process' ? (
							template.children?.length > 0 ? (
								<WorkProcess
									title={template.title}
									data={template.children}
									active={secObj?.[`sec${key + 1}`]}
								/>
							) : null
						) : null}

						{type == 'testimonials' ? (
							pageData.testimonials?.length > 0 ? (
								<Testimonials
									full
									dark
									title={'testimo</br>nials'}
									items={pageData.testimonials}
								/>
							) : null
						) : null}

						{type == 'choose' ? (
							template.children?.length > 0 ? (
								<WhyChoose
									title={template.title}
									items={template.children}
								/>
							) : null
						) : null}

						{type == 'title_and_description' ? (
							<TableItem
								minWidth
								underline
								animationDelay={0.1}
								title={template.title}
								active={secObj?.[`sec${key + 1}`]}
								description={template.description}
							/>
						) : null}
					</div>
				);
			})
		);
	}, [pageData, secObj]);

	return (
		<Page>
			<SubServiceStyle className={'singleServices'}>
				<HTMLContainer>
					<AnimationWrap state={Anim}>
						<PageTopSection
							font={'h3'}
							button
							back
							{...pageData.hero}
						/>

						{sectionBuilder}

						<div className={`section-item portfolioRow`}>
							<PortfolioShortList
								portfolioFull
								serviceType={pageData?.type}
								title={'featured</br> works'}
								active={pageData.templates?.length > 0 ? secObj?.[`sec${pageData.templates?.length + 2}`] : secObj?.sec2}
							/>
						</div>
					</AnimationWrap>
				</HTMLContainer>
			</SubServiceStyle>
		</Page>
	);
};

export default withLanguageContext(SingleSubService, ['translate']);
